<script setup lang="ts">
  import { FlowQuoteWidgetQC } from '@/widgets/Flow'
</script>

<template>
  <FlowQuoteWidgetQC />
</template>
